import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';

import s from './Tag.module.css';

export type TagVariantsProps = VariantProps<typeof tagVariants>;

export const tagVariants = cva(s.tag, {
  defaultVariants: {
    color: 'default',
  },
  variants: {
    color: {
      accent: s.c_accent,
      'accent-alt': s['c_accent-alt'],
      default: s.c_default,
      success: s.c_success,
      transparent: s.c_transparent,
      warning: s.c_warning,
    },
  },
});
